var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "risk-control-box" },
    [
      _c("div", { staticClass: "search-criteria" }, [
        _c(
          "div",
          [
            _c("el-input", {
              attrs: { placeholder: "输入账号查询", clearable: "" },
              model: {
                value: _vm.queryData.account,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "account", $$v)
                },
                expression: "queryData.account",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择账号类型", clearable: "" },
                model: {
                  value: _vm.queryData.accountType,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "accountType", $$v)
                  },
                  expression: "queryData.accountType",
                },
              },
              [
                _c("el-option", { attrs: { label: "所有", value: "" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "手机号", value: "phone" } }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "支付宝", value: "alipay" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "date-range" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "风控开始时间",
                "end-placeholder": "风控结束时间",
                "value-format": "yyyy-MM-dd HH:mm:ss",
              },
              model: {
                value: _vm.queryData.timeRange,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "timeRange", $$v)
                },
                expression: "queryData.timeRange",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", border: "none" },
          },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onInitialize },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px" },
                attrs: { type: "primary", icon: "el-icon-circle-plus-outline" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("\n        新增\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "风控账号类型",
                  prop: "accountType",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.accountType === 2 ? "支付宝" : "手机号"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "账号", prop: "account", "min-width": "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "风控原因",
                  prop: "reason",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "添加人", prop: "adder", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "添加来源", prop: "source", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "风控时间", prop: "riskTime", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-edit" }),
                            _vm._v(" 编辑\n          "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#f56c6c" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onRelease(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-unlock" }),
                            _vm._v(" 解除\n          "),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.queryData.page.size,
                  total: _vm.pagination.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("RiskControlDialog", {
        ref: "RiskControlDialog",
        on: { refresh: _vm.onRefresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }